import styled from 'styled-components';
import { MediaQuery } from '../../theme/style-helpers';

export const Icon = styled.img`
    margin-right: 10px;

    &.right {
        margin-right: 0;
        margin-left: 10px;
    }
`;

export const FormContainer = styled.div`
    width: 100%;
    padding: 72px 0;
    margin: 0 auto;
`;

export const ButtonGroup = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 72px;
    margin-top: 50px;
`;

export const PageTitle = styled.div`
    font-weight: 300;
    font-size: 4.8rem;

    &.justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }
`;
export const TextProperty = styled.div`
    font-size: 1.4rem;
    font-weight: 500;

    ${MediaQuery.medium`
        margin-bottom: 15px;
    `}

    .title {
        margin-bottom: 10px;
    }

    .text {
        font-weight:800;
        font-size:1.6rem;
    }

    .justified {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    hr {
        border-color: #000;
        margin: 1.5rem 0 3rem;
    }
`;

export const ContactColumn = styled.div`
    display: grid;
    grid-gap: 32px;
    margin-top: 32px;

    .tooltip-message {
        z-index: 1;
    }

    .field-tooltip {
        div {
            div:first-child {
                gap: 8px;
                justify-content: start;
            }
        }
    }
`;

export const RadioFieldContainer = styled.div`
    position: relative;
    display: grid;
    grid-auto-flow: row;
    row-gap: 8px;
    grid-auto-rows: max-content;
`;

export const RadioField = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 32px;
`;

export const FieldLabel = styled.label`
    display: flex;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    margin: 0;
    padding-right: 4px;
    gap: 8px;
`;
